import store from "./store"
import { setterAction } from "../common/redux"
import * as t from "./actionTypes"

export const showLoadingScreen = setterAction(t.SHOW_LOADING_SCREEN)
export const showCovid19AlertBanner = setterAction(t.SHOW_COVID19_ALERT_BANNER)
export const _setLocale = setterAction(t.SET_LOCALE)

const snapshots = {}

export const setLocale = (locale) => (dispatch) => {
  console.log(locale)
  localStorage.setItem("locale", locale.value)
  window.location.reload()
}

export const takeSnapshot = name => {
  snapshots[name] = { ...store.getState() }
}

export const restoreSnapshot = name => {
  if (!snapshots[name]) {
    return recycle()
  }
  store.dispatch({ type: t.RESTORE, snapshot: snapshots[name] })
}

export const recycle = () => {
  store.dispatch({ type: t.RESTORE, snapshot: snapshots["init"] })
  // dispatch loading screen after snapshot so that action is not undone
  store.dispatch(showLoadingScreen(true))
  setTimeout(() => {
    store.dispatch(showLoadingScreen(false))
  }, 1000)
}

//Helper method for testing
export const setState = state => {
  store.dispatch({ type: t.RESTORE, snapshot: state })
}



// WEBPACK FOOTER //
// ./assets/redux/actions.js